import { TextFieldModule } from '@angular/cdk/text-field';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { ExperimentCreateImportDatasetComponent } from '@components/experiment-create-import-dataset/experiment-create-import-dataset.component';

@NgModule({
    declarations: [ExperimentCreateImportDatasetComponent],
    exports: [ExperimentCreateImportDatasetComponent],
    imports: [MatCardModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatMomentDateModule, TextFieldModule]
})
export class ExperimentCreateImportDatasetModule { }